import {
  Directive,
  ElementRef,
  Input,
  OnChanges,
  Renderer2,
  SimpleChanges,
} from '@angular/core';

@Directive({
  selector: '[appShowSpinner]',
})
export class ShowSpinnerDirective implements OnChanges {
  // tslint:disable-next-line:no-input-rename
  @Input('appShowSpinner') showSpinner: boolean;

  originalInnerText: string;
  span: HTMLSpanElement;

  iconButton: HTMLElement | null = null;

  constructor(private el: ElementRef, private renderer: Renderer2) {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes.showSpinner.currentValue) {
      this.renderer.addClass(this.el.nativeElement, 'spinner');
      this.renderer.setProperty(this.el.nativeElement, 'disabled', true);
    } else {
      this.renderer.removeClass(this.el.nativeElement, 'spinner');
      this.renderer.setProperty(this.el.nativeElement, 'disabled', false);
    }
  }
}
